import Fuse from 'fuse.js'

export function initSearchForm() {
	const searchData = JSON.parse($('#data--search').text())
	const fuse = new Fuse(searchData, {
		shouldSort: true,
		caseSensitive: true,
		tokenize: true,
		threshold: 0.2,
		keys: ['keyword']
	})
	const $data = $('#search-datalist')

	$('form.search').once('initBetterSearch').each(function () {
		const $search = $(this)
		const $input = $search.find('.search__input')
		$input.on('input', function (e) {
			const searchString = $input.val()
			const results = fuse.search(searchString)

			// Get just the first result; too many similar results looks weird.
			const result = results.slice(0, 1)
			const $toAdd = []
			result.forEach(function ({keyword}) {
				const $result = $data.find(`option[value="${keyword}"]`)
				if (!$result.length) {
					$toAdd.push($(`<option value="${keyword}" class="autocomplete-results"></option>`))
				}
			})

			const keywords = results.map(({keyword}) => keyword)
			$data.find('.autocomplete-results').each(function () {
				const $result = $(this)
				const value = $result.attr('value')
				if (!keywords.includes(value)) {
					$result.remove()
				}
			})
			$data.append($toAdd)
		})

		$search.on('submit', function (e) {
			const searchString = $input.val()
			const results = fuse.search(searchString)

			if (results.length) {
				const result = results[0]
				window.location.href = result.pageToVisit

				e.preventDefault()
				e.stopPropagation()
			}
		})
	})
}